import React from 'react'
import { InputProps } from 'antd/lib/input/Input'
import styles from './WithLabel.module.scss'

interface Props extends InputProps {
  children?: JSX.Element
  label?: string
  icon?: JSX.Element
  required?: boolean
}

const WithLabel: React.FC<Props> = ({ children, label, icon, className, required, ...props }) => {
  return (
    <div className={styles.container}>
      {label && (
        <div className={styles.label}>
          {icon}
          {label}
          {required && <span className={styles.required}>*</span>}
        </div>
      )}
      {children && React.cloneElement(children, props)}
    </div>
  )
}

export default WithLabel
